import React from "react";

interface SmeReviewStatsComponentProps {
  pendingMeasuresCount: number;
  performanceAreasRemaining: number;
  daysToSmeDeadline?: number | string;
}

const SmeReviewStatsComponent: React.FC<SmeReviewStatsComponentProps> = ({
  pendingMeasuresCount,
  performanceAreasRemaining,
  daysToSmeDeadline = "-",
}) => {
  return (
    <div className="sme-stats-grid">
      <div className="sme-stat-cell">
        <div className="sme-stat-label">My Pending Measures</div>
        <div className="sme-stat-value">{pendingMeasuresCount}</div>
      </div>
      <div className="sme-stat-cell">
        <div className="sme-stat-label">Total Performance Areas Remaining</div>
        <div className="sme-stat-value">{performanceAreasRemaining}</div>
      </div>
      <div className="sme-stat-cell">
        <div className="sme-stat-label">Days to SME Deadline</div>
        <div className="sme-stat-value">{daysToSmeDeadline}</div>
      </div>
    </div>
  );
};

export default SmeReviewStatsComponent;
